import * as c from '../constants';
import { onWaiting, getMyUsers } from '../../Actions';
import _ from 'lodash';

const onGetMeasurements = (data) => ({
    type: c.MEASUREMENTS,
    data
})

export const getMeasurements = () => {
    return (dispatch, getState, { api, session }) => {
        api.get('/me/measurement')
            .then(response => {
                if(!response) return;
                const { measurements } = response;
                if(!measurements) {
                    const profile = session.getItem('profile');
                    return dispatch(onGetMeasurements({
                        user_id: profile.id,
                        username: profile.username
                    }))
                }
                dispatch(onGetMeasurements(measurements));
            })
    }
}


export const getMeasurementsByUser = (params) => {
    return (dispatch, getState, { api }) => {
        const myUser = getMyUsers().filter(item => item.username === params.username);
        if(myUser.length > 0) {
            const noMeasurement = {
                user_id: myUser[0].id
            }
            dispatch(onGetMeasurements(noMeasurement));
        }
        api.get('/stance', { username: params.username }, dispatch)
            .then(response => {
                if(!response) return;
                const { measurements } = response;
                dispatch(onGetMeasurements(measurements));
            })
    }
}

export const getStance = (data) => {
    return (dispatch, getState, { api, alert, history, session }) => {
        const profile = session.getItem('profile');
        let username = profile.id;
        
        if(!_.isNil(data.username)) {
            username = data.username;
        }

        const params = Object.assign({}, data, {
            username
        })

        dispatch(onWaiting(true));
        api.post('/stance', params, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return;
                const { message } = response;
                alert.success(message);
                if(_.isEmpty(username)) {
                    return history.push(`/billing/stance-width`);
                }
                history.push(`/billing/${username}/stance-width`);
            })
    }
}


// WEBPACK FOOTER //
// ./src/stance/actions/index.js